import { render, staticRenderFns } from "./payment-moves.vue?vue&type=template&id=17d07c96&"
import script from "./payment-moves.vue?vue&type=script&lang=ts&"
export * from "./payment-moves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports